const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/

const isoDayAsDate = (isoDay: string | undefined): Date | null => {
  const match = ISO_DAY.exec(isoDay ?? '')
  if (!match) return null

  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

export default isoDayAsDate
